import { render, staticRenderFns } from "./RoomsScreen.vue?vue&type=template&id=4673ff04&scoped=true"
import script from "./RoomsScreen.vue?vue&type=script&lang=js"
export * from "./RoomsScreen.vue?vue&type=script&lang=js"
import style0 from "./RoomsScreen.vue?vue&type=style&index=0&id=4673ff04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4673ff04",
  null
  
)

export default component.exports